import { render } from "./customerEdit.vue?vue&type=template&id=5b9499b1&scoped=true"
import script from "./customerEdit.vue?vue&type=script&lang=js"
export * from "./customerEdit.vue?vue&type=script&lang=js"

import "./customerEdit.vue?vue&type=style&index=0&id=5b9499b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b9499b1"]])

export default __exports__